import { useMemo } from 'react';

interface UseAllTaskPresentationsPriceRecordedProps {
  productsFromTask?: any[];
  triggeredFromTask: boolean;
}

export function useAllTaskPresentationsPriceRecorded({
  productsFromTask,
  triggeredFromTask,
}: UseAllTaskPresentationsPriceRecordedProps) {
  return useMemo(() => {
    if (!triggeredFromTask || !productsFromTask || productsFromTask.length === 0) {
      return {
        allPresentationsPriceRecorded: false,
        recordedCount: 0,
        totalCount: productsFromTask?.length || 0,
        completionPercentage: 0,
      };
    }

    const recordedCount = productsFromTask.filter(
      (p: any) => p?.priceAdded === true || !!p?.priceData || p?.isDelegated === true
    ).length;

    const totalCount = productsFromTask.length;
    const allPresentationsPriceRecorded = recordedCount === totalCount;
    const completionPercentage = totalCount > 0 ? Math.round((recordedCount / totalCount) * 100) : 0;

    return {
      allPresentationsPriceRecorded,
      recordedCount,
      totalCount,
      completionPercentage,
    };
  }, [productsFromTask, triggeredFromTask]);
}
